import styles from '@/styles/csotd/goodsComponentWithGrab.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import ClockIcon from '@/svgs/clock-icon.svg'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const apiDomain = publicRuntimeConfig.apiDomain
const inspectionModeEnabled = publicRuntimeConfig.inspectionModeEnabled === true
const strikethroughPriceVisible = publicRuntimeConfig.strikethroughPriceVisible === true

interface GoodsDetail {
  productID: string;
  productName: string;
  url: string;
  imgUrl: string;
  promotion: any;
  review: number;
  reviewCount: number;
  price: number;
  normalPrice: number;
  tagTitle: string;
  tagBgColor: string;
  tagFontColor: string;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any,
  promotionTypeID: string | number;
  [key: string]: any;
}

export default function GoodsComponentWithDiscount(props: GoodsDetail) {
  let price = `${Number(props.normalPrice).toFixed(2)}`.split('.')
  if (props.normalPrice && props.price != props.normalPrice) {
    price = `${Number(props.price).toFixed(2)}`.split('.')
  }

  // 跳转到商品详情页面
  const handleViewProductDetail = () => {
    window.location.href = `${apiDomain}${props?.url}`
  }

  return (
    <div className={`${styles['goods-box']}`}>
      <div className={styles['imgthumb']}>
        <Link
          href={props.url}
          legacyBehavior
        >
          <a className={styles['goodsLink']} rel="noopener noreferrer">
            <Image
              src={props.imgUrl}
              alt={props.productName}
              width={200}
              height={200}
            />
          </a>
        </Link>
      </div>
      <div className={styles['goods-info']}>
        <Link
          href={props.url}
          legacyBehavior
        >
          <a className={styles['goodsLink']} rel="noopener noreferrer">
            <h3 className={styles['goods-name']} dangerouslySetInnerHTML={{ __html: props.productName }} />
          </a>
        </Link>
        <div className={styles['goods-price']}>
          <div className={styles['price']}>
            <b>${price[0]}<i>.{price.length === 2 ? price[1] : '00'}</i></b>
          </div>
          {
            strikethroughPriceVisible && (props.normalPrice && props.price != props.normalPrice)
            &&
            <div className={styles['crossedPrice']}>
              <b>$ {props.normalPrice}</b>
            </div>
          }
        </div>

        {!inspectionModeEnabled && <div className={styles['goods-discount']}>
          {
            !!(props.promotion && props.promotion?.promotionRate) &&
            <div>
              {
                (props.normalPrice - props?.price >= 100)
                ?
                <div className={styles['discount']}>Save ${(props.normalPrice - props?.price).toFixed(2)}</div>
                :
                <div className={styles['discount']}>{(((props.normalPrice - props.price) / props.normalPrice) * 100).toFixed(0)}% OFF</div>
              }
            </div>
          }
        </div>}

        <div
          className={styles['grab-it-now']}
          onClick={handleViewProductDetail}
        >
          <ClockIcon width={'24px'} style={{ marginRight: '12px' }}></ClockIcon>
          Grab It Now!
        </div>
      </div>
    </div>
  )
}
